<div class="card-novo-lg">
  <a (click)="onCardClick()" class="block no-underline">
    <div class="flex flex-col p-0 h-[220px]">
      @if (getRole() == 'UTILISATEUR') {
        <div class="flex-grow flex text-center items-center p-0 rounded-t-[23px] bg-blueCielNovo justify-center p-0  h-7/10 w-5/5 overflow-visible">
          <mat-icon class="material-symbols-outlined object-cover  icon-in-card text-white" >person</mat-icon>
        </div>
      }
      @if (getRole() == 'ADMIN') {
        <div class="flex-grow flex text-center items-center rounded-t-[23px] p-0  bg-vertClairNovo justify-center  h-7/10 w-5/5 overflow-visible">
          <mat-icon class="material-symbols-outlined object-cover icon-in-card text-white" >factory</mat-icon>
        </div>
      }
      @if (getRole() == 'PILOTE') {
        <div class="flex-grow flex text-center items-center p-0 rounded-t-[23px] bg-roseFonceNovo justify-center  h-7/10 w-5/5 overflow-visible">
          <mat-icon class="material-symbols-outlined object-cover icon-in-card text-white" >apartment</mat-icon>
        </div>
      }
      <div class="flex items-center object-cover footer-card justify-center pt-2 h-3/10 rounded-b-[22px]">
        <h4>{{ entiteUtilisateur.entiteNom }} @if (!entiteUtilisateur.estActif) {
          <span class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
        }</h4>
      </div>
    </div>
  </a>
</div>
<div class="text-start mt-1 h-[70px] pr-2 pl-2">
  <ul class="list-disc list-inside pr-2 pl-2">
    @for (role of entiteUtilisateur.roleEntites; track role) {
      <li class="titre4 text-sm">
        {{ utilisateurService.getNomLocalise(role.denominations) }} - {{ role.nomEntite }}
      </li>
    }
  </ul>
</div>
